var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenticateRLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11545_64401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.835 18.5035L0 29H6.24455L8.45503 22.6453L3.835 18.5035Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0739 16.8774L13.1821 7.59577C14.046 10.175 14.9099 12.7562 15.7738 15.3355L20.5347 11.9002L16.1888 0H10.6392L4.97681 15.6027L10.0739 16.8774Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9429 21.5594L20.5815 29H26.8261L22.2173 16.3859L17.9429 21.5594Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67432 16.0831L12.9135 18.6511L28.0018 7.77707L13.306 25.6021L2.67432 16.0831Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4758 16.7293C23.4758 16.2491 23.8175 15.8868 24.3196 15.8868C24.8216 15.8868 25.1661 16.2463 25.1661 16.7293C25.1661 17.2123 24.8216 17.569 24.3196 17.569C23.8175 17.569 23.4758 17.2137 23.4758 16.7293ZM24.3196 17.3733C24.6933 17.3733 24.9569 17.1012 24.9569 16.7293C24.9569 16.3573 24.6933 16.0811 24.3196 16.0811C23.9459 16.0811 23.685 16.3573 23.685 16.7293C23.685 17.1012 23.9459 17.3733 24.3196 17.3733ZM23.9583 16.2671H24.3865C24.5762 16.2671 24.6738 16.3823 24.6738 16.5266C24.6738 16.6363 24.625 16.7098 24.519 16.7418C24.7227 16.7931 24.6347 17.0693 24.7031 17.1803H24.4772C24.3907 17.0166 24.5065 16.8306 24.2931 16.8306H24.1871V17.1803H23.9583V16.2671ZM24.1871 16.4531V16.6613H24.3126C24.3935 16.6613 24.4381 16.6266 24.4381 16.5586C24.4381 16.4906 24.3991 16.4531 24.3126 16.4531H24.1871Z",
    fill: "#4795C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11545_64401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticateRLogo);
export default __webpack_public_path__ + "static/media/Authenticate_ R_Logo.fdc63c6c07fd1494d0fc6f48a16f9aac.svg";
export { ForwardRef as ReactComponent };